import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bg-banner',
  templateUrl: './bg-banner.component.html'
})
export class BgBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
